var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 150,
    viewBox: "230 230 345 345",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 1122.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157 548.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 21.333 41.333h-41.666l-7.334-14h26.334l-33.334-64.666h-59.666l-6.851-13.334h75.851l18.666 37.334h21.334l-19.334-37.334h14l26.667 50.667z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.67 576.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 9,13.667 H -43.667 L -51,0 Z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.67 509.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13.667 26.333h3.666l6.334 12.667h-38.667l-7.917-8.333-1.75-4.334 23.667 0.334-13-25.334 0.667-13h11l6.666 11.667z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.75 548.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-19.458-39.417h-6.959l13.917 27-1.5 12.417h-10.25l-6-12.917h4.333l-14.583-26.25h-3.5l-6.583-11.5h39.083l26.75 50.667z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.5 584.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-38.75-73.75h-32.25l13.191 25h10.309l6.5 12.667h-10.126l6.376 12.083-17.5-5.75-3.67-6.333h-22.33l-9.75-9.667-1.25-3h5.5l-20-38h14.5l20.25 37.75h6.75l-13-25.5 1.25-12.25h54.5l45.25 86.75z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.75 561.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-13.25l-5.25-9.5h13.75z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.75 548.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-19.5-37.167h-7l19.75 37.167h-13.75l-20.25-37.667h-28.25l-6.25-13h63.25l26 50.667z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(495.5 534.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.25 12.5h-18.5l18.5 37.25h-16.5l-37.5-73h-7.75l13.25 24.75-1 12.167h-8.25l-9.75-8.917-1.75-3.5h6l-19.75-38.25h37l19.25 37z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.79 510.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.792-13h70.75l7.75 13z",
    fill: "#df1b4f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527.5 572.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.5 12.5h-30.5l-6.25-12.5z",
    fill: "#df1b4f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bc490a3d6f959cebd9f4c5aed980dbdb.svg";
export { ForwardRef as ReactComponent };